module.exports = __webpack_public_path__ + "assets/cb98b43c1a5d4a3018d5e46b28488fe1.png";